/**
 * Returns the display name for an inventory item: "{name} - {brand}" when
 * brand is present, otherwise just "{name}". Mirrors InventoryItem.DisplayName
 * on the backend.
 */
export const getInventoryItemDisplayName = (
  name: string,
  brand?: string | null,
): string => {
  return brand?.trim() ? `${name} - ${brand.trim()}` : name;
};
